import { useContext } from 'react';
import { TimezoneContext } from 'src/features/timezone/context/TimezoneProvider';
import { TimezoneContextValue } from 'src/features/timezone/types/timezone.types';

export const useTimezone = (): TimezoneContextValue => {
  const context = useContext(TimezoneContext);
  if (!context) {
    throw new Error('useTimezone must be used within a TimezoneProvider');
  }
  return context;
};
